import { mask, unMask } from '@/lib/form-state/util'
import { toZonedTime } from 'date-fns-tz'

/**
 * Helpers de formatação da tela de agendamento.
 *
 * Vivem fora do `scheduling-form-page.tsx` porque são puros e porque os componentes
 * extraídos da tela precisam deles — deixá-los no arquivo da página obrigaria cada
 * componente a recebê-los por prop ou a reimplementar a conta.
 */

/** `datetime-local` (hora de São Paulo) → ISO em UTC, para o backend. */
export const convertLocalToUTC = (localDateTimeString: string): string => {
    if (!localDateTimeString) return ''
    const zonedDate = toZonedTime(localDateTimeString, 'America/Sao_Paulo')
    return zonedDate.toISOString()
}

/** Centavos → `R$ 1.234,56`. */
export const formatCentsLabel = (cents: number): string =>
    `R$ ${(cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

/**
 * Máscara de moeda. `allowEmpty` devolve string vazia quando só há zeros — é o que
 * permite um campo de valor ficar em branco em vez de exibir "R$ 0,00".
 */
export const currencyFormat = (
    value: string | number | null | undefined,
    allowEmpty = false
) => {
    if (value === null || value === undefined) value = '0'
    const digits = `${value}`.replace(/[^0-9]+/g, '')
    if (
        allowEmpty &&
        (!digits || digits === '0' || digits === '00' || digits === '000')
    )
        return ''
    return mask(digits, '', 'currency', {
        prefix: 'R$ ',
        decimalSeparator: ',',
        groupSeparator: '.',
        precision: 2,
    })
}

export const parseCurrencyToCents = (value: string): number => {
    if (!value.trim()) return 0
    return parseInt(unMask(value, 'currency'))
}
